import { render, staticRenderFns } from "./verticalSubTable.vue?vue&type=template&id=aa80930e&"
import script from "./verticalSubTable.vue?vue&type=script&lang=js&"
export * from "./verticalSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/verticalSub/verticalSubTable.vue"
export default component.exports